/**
 * ==========================================================
 * TITANPATH - Scroll Animations
 * ==========================================================
 *
 * Sistema de animaciones al entrar en el viewport.
 *
 * Clase base:
 *
 *     .titanpath-animation
 *
 * Animaciones:
 *
 *     .titanpath-animation-fade
 *     .titanpath-animation-fade-up
 *     .titanpath-animation-fade-down
 *     .titanpath-animation-fade-left
 *     .titanpath-animation-fade-right
 *     .titanpath-animation-scale
 *     .titanpath-animation-scale-up
 *
 * Cuando el elemento entra en pantalla, JS agrega:
 *
 *     .titanpath-animation-visible
 *
 * ==========================================================
 */


/**
 * Inicializa las animaciones al hacer scroll.
 */
export function initAnimations() {

    // ------------------------------------------------------
    // Elementos animables
    // ------------------------------------------------------

    const animatedElements = document.querySelectorAll(
        '.titanpath-animation'
    );


    // Si no existen elementos animados, terminamos.
    if (!animatedElements.length) {
        return;
    }


    // ------------------------------------------------------
    // Elementor Editor
    // ------------------------------------------------------
    //
    // Cuando estamos editando una página con Elementor,
    // NO queremos ocultar los elementos.
    //
    // Elementor agrega "elementor-editor-active" al body
    // mientras estamos dentro del editor.
    //
    // En este caso agregamos directamente la clase visible
    // para que todo el contenido permanezca visible.
    //
    if (document.body.classList.contains('elementor-editor-active')) {

        animatedElements.forEach((element) => {

            element.classList.add(
                'titanpath-animation-visible'
            );

        });

        return;
    }


    // ------------------------------------------------------
    // Reduced Motion
    // ------------------------------------------------------
    //
    // Respetamos la configuración del sistema operativo
    // del usuario para reducir movimiento.
    //
    const prefersReducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
    ).matches;


    if (prefersReducedMotion) {

        animatedElements.forEach((element) => {

            element.classList.add(
                'titanpath-animation-visible'
            );

        });

        return;
    }


    // ------------------------------------------------------
    // Intersection Observer
    // ------------------------------------------------------
    //
    // Detecta cuándo un elemento entra en el viewport.
    //
    // threshold: 0.15
    //
    // La animación comienza cuando aproximadamente el 15%
    // del elemento es visible.
    //
    const observer = new IntersectionObserver(
        (entries, observer) => {

            entries.forEach((entry) => {

                // Si todavía no está visible, esperamos.
                if (!entry.isIntersecting) {
                    return;
                }


                // Activa la animación CSS.
                entry.target.classList.add(
                    'titanpath-animation-visible'
                );


                // Dejamos de observar el elemento.
                //
                // La animación solo ocurre una vez.
                observer.unobserve(entry.target);

            });

        },
        {
            threshold: 0.15
        }
    );


    // ------------------------------------------------------
    // Observar elementos
    // ------------------------------------------------------

    animatedElements.forEach((element) => {

        observer.observe(element);

    });

}